import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "add-account"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getRoleSelectList, addAccount } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddAccountModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const form = ref({
      loginName: '',
      manageLinkMan: '',
      ManagerRole: '2',
      note: '',
      supUserId: '',
      addCount: 0,
      storeCount: '',
      flag: 1
    });
    const formRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, newVal => {
      if (newVal && !props.editData) {
        formRef.value.resetFields();
        form.value.ManagerRole = '2';
      } else if (props.editData) {
        const roleId = props.editData.ManagerRole || props.editData.roleId || '2';
        form.value = _objectSpread(_objectSpread(_objectSpread({}, form.value), props.editData), {}, {
          ManagerRole: String(roleId),
          flag: 2
        });
      }
    }, {
      flush: 'post'
    }); // 内置分管 + 自定义分管角色

    const BUILTIN_MANAGER_ROLE = {
      id: '2',
      text: '分管'
    };
    const roleSelectList = ref([BUILTIN_MANAGER_ROLE]);
    getRoleSelectList({
      roleType: 2
    }).then(data => {
      const list = Array.isArray(data) ? data.filter(item => item && item.id !== '') : [];
      const hasBuiltin = list.some(item => String(item.id) === '2');
      roleSelectList.value = hasBuiltin ? list : [BUILTIN_MANAGER_ROLE, ...list];
    }).catch(() => {
      roleSelectList.value = [BUILTIN_MANAGER_ROLE];
    });

    function confirm() {
      formRef.value.validate(result => {
        if (result) {
          addAccount(_objectSpread(_objectSpread({}, form.value), {}, {
            flag: props.editData ? 2 : 1,
            __repeat: true,
            __warn: true
          })).then(data => {
            if (data.success) {
              visible.value = false;
              ElMessage({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              emit('success');
            }
          });
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.editData ? '编辑账号' : '新增账号',
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "登录账号:",
                prop: "loginName",
                disabled: "",
                rules: {
                  required: !__props.editData,
                  message: '请填写登录账号'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  readonly: !!__props.editData,
                  modelValue: form.value.loginName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.loginName = $event),
                  placeholder: ""
                }, null, 8, ["readonly", "modelValue"])]),
                _: 1
              }, 8, ["rules"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "姓名:",
                prop: "manageLinkMan",
                rules: {
                  required: true,
                  message: '请填写姓名'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.manageLinkMan,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.manageLinkMan = $event),
                  placeholder: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "角色:",
                prop: "ManagerRole",
                rules: {
                  required: true,
                  message: '请选择角色'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.ManagerRole,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.ManagerRole = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleSelectList.value, role => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: role.text,
                      value: role.id + '',
                      key: role.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注:",
                prop: "note"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  autosize: {
                    minRows: 4,
                    maxRows: 6
                  },
                  modelValue: form.value.note,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.note = $event),
                  width: "100%",
                  placeholder: "填写备注"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};